import React from 'react';
import { RouteObject } from 'react-router-dom';
import { appRoutes } from '../../path';
import Workspace from './Workspace';
import Workspaces from './Workspaces';
import WorkspaceLayout from './WorkspaceLayout';

const workspaceRoutes: RouteObject[] = [
  {
    element: <WorkspaceLayout />,
    children: [
      {
        path: appRoutes.workspaces.routePrefix,
        element: <Workspaces />,
        children: [
          {
            path: appRoutes.workspaces.routePrefix + '/:workspaceId',
            element: <Workspace />,
          },
        ],
      },
    ],
  },
];

export default workspaceRoutes;
